export var convertStringToMilliseconds = function (value) {
    var hours = Number(value.substr(0, 2)) * 3600;
    var minutes = Number(value.substr(3, 2)) * 60;
    var seconds = Number(value.substr(6, 2));
    return (hours + minutes + seconds) * 1000;
};
export var isNumber = function (value) {
    var num = Number(value);
    return !isNaN(num) && String(value) === String(num);
};
export var leadingZero = function (timeValue) {
    if (timeValue >= 0 && timeValue <= 9) {
        return "0" + timeValue;
    }
    else if (timeValue <= 0) {
        return '00';
    }
    else {
        return timeValue.toString();
    }
};
export var clamp = function (value, min, max) { return value <= min ? min : value >= max ? max : value; };
export var convertMillisecondsToString = function (value) {
    var time = value / 1000;
    var hours = leadingZero(Math.floor(time / 3600));
    var minutes = leadingZero(Math.floor((time / 60) % 60));
    var seconds = leadingZero(Math.floor(time % 60));
    return hours + ":" + minutes + ":" + seconds;
};
//# sourceMappingURL=index.js.map